import React, { useState, useEffect } from "react";
import { Layout, Menu, Dropdown } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SwitcherFilled,
  ControlOutlined,
  FileAddOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import { Link, NavLink, useHistory } from "react-router-dom";
import { decode as tokenDecoder } from "../../../utils/tokenDecoder";

const { Title } = Typography;

const { Header, Sider, Content } = Layout;

const Dashboard = (props) => {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logout = () => {
    localStorage.removeItem("x-auth-token");
    history.push("/auth/login");
    window.location.reload();
  };
  const token = localStorage.getItem("x-auth-token");
  const userData = token && tokenDecoder(token);

  const menu = (
    <Menu>
      <Menu.Item>
        <Link to="/account/settings">My Profile</Link>
      </Menu.Item>
      <Menu.Item onClick={logout}>
        <Link to="#">Logout</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="height-full">
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo" />
        <div className="dashboard-menu" />
        <Menu
          className="dashboard-menu"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
        >
          <Menu.Item key="/dashboard" icon={<FileAddOutlined />}>
            <NavLink to="/dashboard" className="nav-text">
              Dashboard
            </NavLink>
          </Menu.Item>
          <Menu.Item key="/dashboard/manage-users" icon={<FileAddOutlined />}>
            <NavLink to="/dashboard/manage-users" className="nav-text">
              Manage users
            </NavLink>
          </Menu.Item>
          <Menu.Item key="/home" icon={<SwitcherFilled />}>
            <a href="/home" target="_blanket" className="nav-text">
              Live site
            </a>
          </Menu.Item>
          <Menu.Item key="3" icon={<ControlOutlined />} onClick={logout}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{ padding: 0 }}
        >
          <div className="between-flex-row">
            <div>
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: toggle,
                }
              )}
            </div>
            <div>
              <Dropdown overlay={menu} placement="bottomLeft" arrow>
                <label
                  style={{ color: "#fff", fontSize: "17px", fontWeight: "300", marginRight: "20px" }}
                >
                  {userData.firstName} {userData.lastName} <DownOutlined />
                </label>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: "100vh",
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
